/// <reference types="vite/client" />
import type { MenuConfig } from '~typings/menu'

import isEmpty from 'lodash/isEmpty'

/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/

const checkMenu = (menu: any): menu is MenuConfig => (typeof menu !== 'object' ? false : Array.isArray(menu) || menu)

const discovery = Object.entries(
    import.meta.glob<MenuConfig[]>(['./*.{js,ts}', './*/index.{js,ts}'], { eager: true, import: 'default' })
)
    .filter(([file, menu]) => {
        const isValidMenu = checkMenu(menu)
        if (import.meta.env.DEV && !isValidMenu) {
            console.warn(`El menú en '${file}' no es válido`)
        }
        return isValidMenu && !isEmpty(menu)
    })
    .sort(([prevFile, prevV], [nextFile, nV]) =>
        prevV[0].title === 'Inicio' ? -10000 : nV[0].title === 'Inicio' ? 10000 : prevFile.localeCompare(nextFile)
    )
    .map(it => it[1])
    .reduce((list, value) => {
        list.push(...value)
        return list
    }, [] as MenuConfig[])

export default discovery
